export enum ConnectorCommand {
  'CREATE' = 'create',
  'REPAIR' = 'repair',
  'DROP' = 'drop'
}
